import { createRoot } from 'react-dom/client';

import './lib/polyfills.ts';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

import '@fontsource-variable/inter';
import '@fontsource-variable/geist-mono';

// Apply theme class before React hydrates to avoid flash
(() => {
  try {
    const cfg = JSON.parse(localStorage.getItem('nostr:app-config') ?? '{}');
    const theme: string = cfg?.theme ?? 'dark';
    document.documentElement.classList.add(theme === 'light' ? 'light' : 'dark');
  } catch {
    document.documentElement.classList.add('dark');
  }
})();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
